// extracted by mini-css-extract-plugin
export var ArticleContainer = "ArticleLeftRightBlock-module--ArticleContainer--c0f24";
export var ArticleContainerReverse = "ArticleLeftRightBlock-module--ArticleContainerReverse--dbf30";
export var articleContent = "ArticleLeftRightBlock-module--articleContent--b5fa7";
export var articleImage = "ArticleLeftRightBlock-module--articleImage--5f26d";
export var capitalize = "ArticleLeftRightBlock-module--capitalize--0518c";
export var date = "ArticleLeftRightBlock-module--date--468f7";
export var desciptionHover = "ArticleLeftRightBlock-module--desciptionHover--de428";
export var fs14 = "ArticleLeftRightBlock-module--fs-14--1cc09";
export var fs16 = "ArticleLeftRightBlock-module--fs-16--4861e";
export var fs20 = "ArticleLeftRightBlock-module--fs-20--f9356";
export var fs24 = "ArticleLeftRightBlock-module--fs-24--39aa3";
export var fs32 = "ArticleLeftRightBlock-module--fs-32--6e096";
export var fs40 = "ArticleLeftRightBlock-module--fs-40--aa72e";
export var fsItalic = "ArticleLeftRightBlock-module--fs-italic--137e4";
export var fsLg = "ArticleLeftRightBlock-module--fs-lg--76cf4";
export var fsMd = "ArticleLeftRightBlock-module--fs-md--ffa9c";
export var fsNormal = "ArticleLeftRightBlock-module--fs-normal--a4c1d";
export var fsSm = "ArticleLeftRightBlock-module--fs-sm--91d92";
export var fsXl = "ArticleLeftRightBlock-module--fs-xl--37f2b";
export var fsXs = "ArticleLeftRightBlock-module--fs-xs--29128";
export var fsXxl = "ArticleLeftRightBlock-module--fs-xxl--2b7fb";
export var fsXxs = "ArticleLeftRightBlock-module--fs-xxs--442c3";
export var fwBold = "ArticleLeftRightBlock-module--fw-bold--49b75";
export var fwMedium = "ArticleLeftRightBlock-module--fw-medium--7b66d";
export var fwNormal = "ArticleLeftRightBlock-module--fw-normal--3d709";
export var gotham_bold = "ArticleLeftRightBlock-module--gotham_bold--1cfcb";
export var gotham_bold_italic = "ArticleLeftRightBlock-module--gotham_bold_italic--f4132";
export var gotham_book = "ArticleLeftRightBlock-module--gotham_book--79fa0";
export var gotham_book_italic = "ArticleLeftRightBlock-module--gotham_book_italic--a0f19";
export var icon = "ArticleLeftRightBlock-module--icon--bb10d";
export var iconContainer = "ArticleLeftRightBlock-module--iconContainer--3d0bc";
export var lowercase = "ArticleLeftRightBlock-module--lowercase--b4a4f";
export var tags = "ArticleLeftRightBlock-module--tags--27772";
export var tagsContainer = "ArticleLeftRightBlock-module--tagsContainer--85d1c";
export var tagsSwiper = "ArticleLeftRightBlock-module--tagsSwiper--3c2c4";
export var title = "ArticleLeftRightBlock-module--title--b1fa8";
export var uppercase = "ArticleLeftRightBlock-module--uppercase--d2309";